import { render, staticRenderFns } from "./SignupPage.vue?vue&type=template&id=d4d10c1a&"
import script from "./SignupPage.vue?vue&type=script&lang=js&"
export * from "./SignupPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports